import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Button } from '@material-ui/core';
import { headerHeight } from 'config/style';
import { Typography } from 'components';
import { signOut } from 'store/account';
import { useAlert, useReduxDispatch, useReduxSelector } from 'store/hooks';
import { useSelector } from 'react-redux';
import UserPhoto from 'views/common/UserPhoto';

const useStyles = makeStyles({
  appBar: {
    height: headerHeight,
    boxShadow: '0 3px 16px 0 rgba(0, 0, 0, 0.13)',
    backgroundColor: '#ffffff',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 20,
  },
  logo: {
    width: 93,
    height: 40,
    objectFit: 'contain',
  },
  photoProfile: {
    display: 'flex',
    padding: '6px 10px',
    borderRadius: 12,
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #dbe1e4',
    backgroundColor: '#f5f5f5',
    boxShadow: 'rgba(100, 100, 111, 0.1) 0px 7px 29px 0px',
    gap: 10,
    // cursor: 'pointer',
    // transition: 'all 0.2s ease-out',
    // '&:hover': {
    //   backgroundColor: 'red'
    // }
  },
});

const Header = () => {
  const classes = useStyles();
  const app = useSelector((state) => state.app);
  const userAccount = useReduxSelector((state) => state.account.data);
  const { hideAlert, alertWaiting, alertError } = useAlert();
  const callSignOut = useReduxDispatch(signOut);

  return (
    <AppBar position="absolute" className={classes.appBar}>
      <img alt="logo" src={app.env.logoUri} className={classes.logo} />
      <div className={classes.photoProfile}>
        <UserPhoto size="sm" nip={userAccount?.nip} />
        <Typography variant="body2">{userAccount.fullname}</Typography>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          style={{
            fontSize: 12,
            textTransform: 'capitalize',
            transition: 'all 0.2s ease-out',
            '&:hover': { backgroundColor: 'red' },
          }}
          onClick={() => {
            alertWaiting('Signing out');
            callSignOut()
              .then(() => hideAlert())
              .catch((error) => alertError(error?.message));
          }}
        >
          Sign out
        </Button>
      </div>
    </AppBar>
  );
};

export default Header;
